module.exports = __webpack_public_path__ + "tadil.jpg?a2094bb34b30e9e93cc02f292dc2de81";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/tadil.jpg
// module id = 317
// module chunks = 0